import moment from 'moment';
import { messages } from './dateOfBirthFormatter.i18n';
import { formati18nDate } from './dateFormatter';

export const formatDateOfBirthWithAge = (language, intl, format, dateOfBirth, isDeceased) => {
  const dateOfBirthMoment = moment(dateOfBirth);
  const dateNowMoment = moment(new Date());

  const formattedDate = formati18nDate(dateOfBirth, language, format).datePart;
  let formattedDateOfBirthWithAge = '';

  if (isDeceased) {
    formattedDateOfBirthWithAge = intl.formatMessage(messages.dobWithAgeDeceasedFormat, { '0': formattedDate });
  } else if (dateNowMoment.diff(dateOfBirthMoment, 'years') >= 2) {
    const ageYears = dateNowMoment.diff(dateOfBirthMoment, 'years');
    formattedDateOfBirthWithAge = intl.formatMessage(messages.dobWithAgeYearsFormat, { '0': formattedDate, '1': ageYears });
  } else {
    const ageMonths = dateNowMoment.diff(dateOfBirthMoment, 'months');
    formattedDateOfBirthWithAge = intl.formatMessage(messages.dobWithAgeMonthsFormat, { '0': formattedDate, '1': ageMonths });
  }

  return formattedDateOfBirthWithAge;
};